export { default as CuratedCatalogPage } from './components/CuratedCatalogPage';
export const CuratedCatalogPageDynamic = () => import('./components/CuratedCatalogPage');
